<template>
  <div class="page-content">
    <div class="flex space-evenly" id="tableList">
      <div class="tables-container">
        <div v-if="user.name" class="space-evenly">
          <div v-if="user.name" id="create-table" class="action-table">
            <div>
              <form class="form-create-table">
                <input
                  class="input-text input-table-name"
                  type="text"
                  v-model="tableName"
                  placeholder="Nome tavolo"
                />
                <select v-model="card_type" class="input-text mr-1">
                  <option>milanesi</option>
                  <option>napoletane</option>
                </select>
                <game-button
                  :formClass="false"
                  @clicked="createTable()"
                  :disabled="clicked || tableName.length == 0"
                >Crea il tavolo</game-button>
              </form>
            </div>
          </div>
        </div>
        <div v-else>
          <text-link
            :title="'Questa è la lista dei tavoli'"
            :route="'/'"
            :labelLink="'Scegli un nickname per giocare'"
          />
        </div>
        <div v-if="loading">
          <h3>Carico i dati</h3>
        </div>
        <div v-else-if="!loading && tables.length == 0">
          <h3>Non ci sono tavoli</h3>
        </div>
        <div v-else-if="!loading">
          <div id="tablesGrid">
            <TableGame
              :table="table"
              v-for="table in tables"
              v-bind:key="table.id"
              v-on:join="join"
              :disabled="clicked"
            />
          </div>
        </div>
      </div>
      <div class="wrap">
        <Chat :messages="messages"/>
        <UsersList />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import TextLink from "./TextLink";
import GameButton from "./Button";
import UsersList from "./UsersList";
import TableGame from "./TableGame";
import Chat from "./Chat"
import EchoInstance from "@/echo.js";
import router from "@/router";

export default {
  name: "TablesList",
  components: {
    TextLink,
    GameButton,
    TableGame,
    UsersList,
    Chat
  },
  data() {
    return {
      query: {
        q: "",
        orderBy: "id",
        order: "ASC",
        page: 1,
        limit: 8
      },
      tableName: "",
      card_type: "milanesi",
      loading: false,
      clicked: false
    };
  },
  mounted() {
    window.Echo.channel("games").listen("TableSeatEvent", e => {
      if (e.user.id == this.$store.getters["user/userId"]) {
        return;
      }
      this.$store.commit("tables/addUserToTableById", e);
    });
    window.Echo.channel("games").listen("TableStandupEvent", e => {
      if (e.user.id != this.user.id) {
        this.$store.commit("tables/deleteUserFromTablesById", e);
      }
    });
    window.Echo.channel("games").listen("CreatedTableEvent", e => {
      this.$store.commit("tables/addTable", e);
    });
    window.Echo.channel("games").listen("DeletedTableEvent", e => {
      this.$store.commit("tables/removeTable", e);
    });
  },
  beforeDestroy() {
    window.Echo.channel("games")
      .stopListening("TableSeatEvent")
      .stopListening("DeletedTableEvent")
      .stopListening("CreatedTableEvent")
      .stopListening("TableStandupEvent");
  },
  computed: {
    ...mapState({
      tables: state => {
        return state.tables.tables;
      },
      users: state => {
        return state.tables.users;
      }
    }),
    ...mapGetters({
      user: "user/user",
      tableActive: "tables/tableActive",
      createdTable: "tables/createdTable",
      messages: "chat/messagesExternal",
      audioSetting: "audioSetting"
    })
  },
  beforeCreate() {
    window.Echo = EchoInstance.getInstance('user');
  },
  created() {
    this.loading = true;
    this.loadData();
  },
  methods: {
    loadData() {
      this.$store.dispatch("tables/fetchTables", this.query).then(() => {
        this.loading = false;
      });
    },
    join(tableId) {
      if (this.clicked) {
        return;
      }
      this.clicked = true;
      const payload = {
        userId: this.user.id,
        tableId: tableId
      };
      if (!isNaN(this.tableActive.id)) {
        window.Echo.channel("table-" + this.tableActive.id).stopListening(
          "GameStartEvent"
        );
        const oldtable = {
          userId: this.user.id,
          tableId: this.tableActive.id
        };
        this.$store
          .dispatch("tables/leaveTable", oldtable)
          .then(() => this.$store.dispatch("tables/joinTable", payload))
          .then(result => {
            this.$store.dispatch("tables/removeMeFromQueue", payload);
            if (!result) {
              const userData = {
                userId: this.user.id
              };
              this.$store.dispatch("user/deleteUser", userData).then(() => {
                this.$store.commit("call/resetCall");
                this.$store.commit("game/exit");
                this.$store.commit("chat/resetChat");
                this.$store.commit("results/resetResults");
                router.push("/");
              });
            } else {
              this.listenGameStart(tableId);
              this.clicked = false;
            }
          });
      } else {
        this.$store.dispatch("tables/joinTable", payload).then(result => {
          if (!result) {
            const userData = {
              userId: this.user.id
            };
            this.$store.dispatch("user/deleteUser", userData).then(() => {
              this.$store.commit("call/resetCall");
              this.$store.commit("game/exit");
              this.$store.commit("chat/resetChat");
              this.$store.commit("results/resetResults");
              router.push("/");
            });
          } else {
            this.listenGameStart(tableId);
            this.clicked = false;
          }
        });
      }
    },
    createTable() {
      this.clicked = true;
      if (this.tableName.length == 0) {
        return;
      }
      const payload = {
        tableName: this.tableName,
        card_type: this.card_type
      };
      this.tableName = "";
      this.$store.dispatch("tables/createTable", payload).then(response => {
        this.clicked = false;
        if (response) {
          this.join(this.createdTable);
        }
      });
    },
    listenGameStart(tableId) {
      window.Echo.channel("table-" + tableId).listen("GameStartEvent", e => {
        if (this.audioSetting) {
          var audio = new Audio(require("../assets/audio/start.mp3"));
          audio.play();
        }
        this.$store.commit("game/resetCards");
        this.$store.dispatch("game/retrieveGameData", e);
        this.$store.dispatch("queued", false);
      });
    }
  }
};
</script>
<style scoped>
@import "../assets/css/app.css";
.page-content {
  margin-bottom: 4em;
}
#tablesContent {
  padding-top: 5em;
}
.action-table {
  margin: 1em;
}
.form-create-table {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.input-table-name {
  margin-right: 1em;
}
.search-table {
  width: 100%;
}
#tablesGrid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: flex-end;
  margin-top: 4em;
}
.space-evenly {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.mr-1 {
  margin-right: 1em;
}
#game-button {
  margin: 1em;
}
.user-button {
  padding: 10px 9px;
}
.tables-container {
  width: 70%;
}
@media all and (max-width: 1000px) {
  #tableList {
    flex-wrap: wrap;
  }
}
@media all and (max-width: 1300px) {
  .wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .tables-container {
    width: 100%;
  }
}

</style>
